"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationResult = exports.ActionSheetResult = exports.ActionType = exports.ToastResult = exports.ToastType = void 0;
var ToastType;
(function (ToastType) {
    ToastType["INFO"] = "general";
    ToastType["FAILURE"] = "failure";
    ToastType["SUCCESS"] = "success";
    ToastType["OFFLINE"] = "offline";
})(ToastType = exports.ToastType || (exports.ToastType = {}));
var ToastResult;
(function (ToastResult) {
    ToastResult["PRESSED"] = "pressed";
    ToastResult["DISMISSED"] = "dismissed";
})(ToastResult = exports.ToastResult || (exports.ToastResult = {}));
var ActionType;
(function (ActionType) {
    ActionType["DEFAULT"] = "default";
    ActionType["PROMINENT"] = "prominent";
    ActionType["DESTRUCTIVE"] = "destructive";
    ActionType["CANCEL"] = "cancel";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var ActionSheetResult;
(function (ActionSheetResult) {
    ActionSheetResult["ACTION_SELECTED"] = "actionSelected";
    ActionSheetResult["DISMISSED"] = "dismissed";
})(ActionSheetResult = exports.ActionSheetResult || (exports.ActionSheetResult = {}));
var NotificationResult;
(function (NotificationResult) {
    NotificationResult["PRESSED"] = "pressed";
    NotificationResult["DISMISSED"] = "dismissed";
})(NotificationResult = exports.NotificationResult || (exports.NotificationResult = {}));
